export const trackClickEvent = (obj) => {
  if (window.adobeAnalytics && window.adobeAnalytics.track) {
    const {
      location,
      category,
      action,
      slotNumber,
      locationDetail,
      platformSelection,
      articleIdName,
      productId,
    } = obj

    window.adobeAnalytics.track('clickevent', {
      location,
      locationDetail,
      category,
      action,
      slotNumber,
      platformSelection,
      articleIdName,
      productId,
    })
  }
}

export const trackImpressionEvent = (obj) => {
  if (window.adobeAnalytics && window.adobeAnalytics.track) {
    const {
      location,
      locationDetail,
      locationPosition,
      category,
      action,
      articleIdName,
      productImpression,
      mdmInstallmentId,
    } = obj

    window.adobeAnalytics.track('impressionevent', {
      location,
      locationDetail,
      locationPosition,
      category,
      action,
      articleIdName,
      productImpression,
      mdmInstallmentId,
    })
  }
}
